import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styles from './PinRequiredModal.css';

class PinRequiredModal extends React.Component {
  render() {
    const { show, onConfirm, mode, message } = this.props;
    const title = mode === 'create' ? 'Invite employee' : 'Save employee';
    return (
      <Modal
        onHide={() => {}}
        show={show}
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header>
          <Modal.Title className={styles.title}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass={`${styles.body} modal-body`}>
          <div>{message}</div>
        </Modal.Body>
        <Modal.Footer>
          <span className="pull-right">
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
            >
              OK
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }
}

PinRequiredModal.propTypes = {
  show: PropTypes.bool,
  onConfirm: PropTypes.func,
  mode: PropTypes.string,
  message: PropTypes.string,
};

PinRequiredModal.defaultProps = {
  message: '',
};

export default PinRequiredModal;
